import { render, staticRenderFns } from "./CartaoFornecedor.vue?vue&type=template&id=2835e96f&scoped=true"
import script from "./CartaoFornecedor.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoFornecedor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoFornecedor.vue?vue&type=style&index=0&id=2835e96f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835e96f",
  null
  
)

export default component.exports